export const bugsnag = {
    bugsnagEnabled: true,
    bugsnagApiKey: 'ac5e73782f3b55fbe385fc1c47c06840',
}
